export default function CustomizationSection() {
  const options = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'LEDライト内蔵',
      description: 'ボトルが光る・暗い店内で映える演出',
      image: 'https://readdy.ai/api/search-image?query=Glowing%20LED%20champagne%20bottle%20in%20dark%20nightclub%20environment%2C%20bright%20colorful%20lights%20emanating%20from%20inside%20the%20bottle%2C%20spectacular%20lighting%20effect%2C%20professional%20photography%2C%20luxury%20presentation%2C%20vibrant%20purple%20and%20golden%20ambient%20lighting&width=600&height=400&seq=custom-led-001&orientation=landscape',
    },
    {
      icon: 'ri-image-edit-line',
      title: 'オリジナルラベルデザイン',
      description: '写真・ロゴ・テキスト入りの完全オーダーメイド',
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/a5cb10944723c6ab94272d059335ed03.jpeg',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'ネックラベル',
      description: 'カラー・ロゴ・テキスト対応',
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/8815e4f04d9681bab31d33113cbdd931.jpeg',
    },
    {
      icon: 'ri-key-2-line',
      title: 'アクリルキーホルダー',
      description: 'ボトルネックに装着・好きな形で制作可',
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/258ec1c9f797d7fe142e56cd87a28d76.jpeg',
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'キャップシール',
      description: 'ゴールド=白・ピンク=ロゼ・シルバー=ノンアル・ブラック=フルーツ系',
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/022efe5589823d8e2c32fff74b77ba16.jpeg',
    },
  ];

  return (
    <section id="customize" className="py-24 bg-gradient-to-b from-purple-950/20 to-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            カスタマイズオプション
          </h2>
          <p className="text-xl text-gray-300">
            あなただけの特別なボトルを作り上げます
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {options.map((option, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl overflow-hidden border border-purple-500/20 hover:border-yellow-400/50 transition-all duration-500 hover:scale-105 cursor-pointer group"
            >
              <div className="relative h-64 md:h-64 overflow-hidden bg-black/30">
                {index === 0 ? (
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/2G3T2caVKwA"
                    title="LED Champagne Demonstration"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <>
                    <img
                      src={option.image}
                      alt={option.title}
                      className={`w-full h-full ${option.title === 'キャップシール' || option.title === 'オリジナルラベルデザイン' || option.title === 'ネックラベル' ? 'object-contain' : 'object-cover object-center'} group-hover:scale-110 transition-transform duration-700`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent"></div>
                  </>
                )}
              </div>
              <div className="p-8">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                    <i className={`${option.icon} text-2xl text-black`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">{option.title}</h3>
                    <p className="text-gray-300 leading-relaxed">{option.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}